import styled from "styled-components";
import { Button, Grid, Checkbox, Typography } from "@material-ui/core";

export const STButton = styled(Button)`
  && {
    text-transform: none;
    margin-top: 24px;
  }
`;

export const STButtonText = styled.span`
  && {
    padding-left: 8px;
  }
`;

export const STGridRoot = styled(Grid)`
  && {
    width: 400px;
  }
`;

export const STGridItem = styled(Grid)`
  && {
    align-items: center;
    display: flex;
  }
`;

export const STGrid = styled(Grid)`
  && {
    flex-direction: column;
  }
`;

export const STCheckbox = styled(Checkbox)`
  && {
    padding: 4px;
  }
`;

export const STText = styled.span`
  && {
    font-size: 1rem;
    text-decoration: underline;
    cursor: pointer;
  }
`;

export const STTypography = styled(Typography)`
  && {
    font-weight: bold;
    padding-bottom: 1rem;
  }
`;

export const STGridButtons = styled(Grid)`
  && {
    padding-top: 1rem;
  }
`;

export const STNoItemsText = styled.div`
  && {
    padding-left: 1rem;
  }
`;
